import { Skeleton } from "antd";

export const searchLoadSkeleton = () => {
  return (
    <div className="search-skeleton">
      {[1, 2, 3, 4, 5]?.map((item) => (
        <Skeleton
          avatar
          active
          paragraph={{
            rows: 1,
          }}
          key={item}
        />
      ))}
    </div>
  );
};
